var __TEMP__ = require('./_castSlice.js');var castSlice = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_hasUnicode.js');var hasUnicode = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_stringToArray.js');var stringToArray = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./toString.js');var toString = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = createCaseFirst;
